export const allImages = [
    '/ranks/1.webp',
    '/ranks/2.webp',
    '/ranks/3.webp',
    '/ranks/4.webp',
    '/ranks/5.webp',
    '/ranks/6.webp',
    '/ranks/7.webp',
    '/ranks/8.webp',
    '/ranks/9.webp',
    '/ranks/10.webp',
    '/icons/256px/car.svg',
    '/icons/256px/prize.svg',
    '/achievements/achievements_background.webp',
    '/achievements/absolute_champion.png',
    '/achievements/audi_expert.png',
    '/achievements/bmw_expert.png',
    '/achievements/clean_race.png',
    '/icons/64px/medal.webp',
    '/icons/64px/prize.webp',
    '/icons/32px/tune.webp',
    '/icons/32px/power.webp',
    '/icons/32px/radius.webp',
    '/icons/32px/speedometer.webp',
    '/icons/32px/stopwatch.webp',
    '/icons/32px/weight.webp',
    '/icons/32px/brake.webp',
    '/icons/32px/fuel.webp',
    '/icons/32px/drive_bias.webp',
    '/icons/32px/car_body.webp',
    '/icons/32px/steering_wheel.webp',
    '/icons/32px/suspension.webp',
    '/icons/32px/tyres.webp',
    '/icons/64px/silver_star.webp',
    '/icons/tunings/pearlescent.png',
    '/icons/tunings/wheel_color.png',
    '/achievements/medal_tilt_underlying.webp',
    '/achievements/financial_champion.png',
    '/achievements/garage_guru.png',
    '/achievements/lada_expert.png',
    '/achievements/mercedes_expert.png',
    '/achievements/pilot_rookie.png',
    '/achievements/podium_king.png',
    '/achievements/premium_collector.png',
    '/achievements/racing_legend.png',
    '/achievements/service_king.png',
    '/achievements/sports_car_fan.png',
    '/achievements/suv_king.png',
    '/achievements/toyota_expert.png',
    '/achievements/track_ace.png',
    '/achievements/tuning_maestro.png',
    '/achievements/wheel_spender.png',
    '/achievements/xp_millionaire.png',
    '/battlepass/abstract_bg.png',
    '/battlepass/prizes/m5f90.png',
    '/icons/24px/back-arrow.svg',
    '/brush_circle.png',
    '/cars/100sc1.png',
    '/cars/2101.png',
    '/cars/2112.png',
    '/cars/2114.png',
    '/cars/220sw111.jpg',
    '/cars/280sew116.png',
    '/cars/360.png',
    '/cars/510.png',
    '/cars/528e12.png',
    '/cars/5ka.png',
    '/cars/600sl.png',
    '/cars/735ie32.png',
    '/cars/745leg11.png',
    '/cars/750ile38.png',
    '/cars/7ka.png',
    '/cars/80b2.png',
    '/cars/850csie31.png',
    '/cars/968M.png',
    '/cars/amgx.png',
    '/cars/asteroj.png',
    '/cars/asteroV.png',
    '/cars/b8.png',
    '/cars/bluebird910.png',
    '/cars/c8t4.png',
    '/cars/corsair.png',
    '/cars/crc55.png',
    '/cars/e63x213.png',
    '/cars/elegyr35.png',
    '/cars/excelsior.png',
    '/cars/expedition.png',
    '/cars/gas24.png',
    '/cars/gas3102.png',
    '/cars/gas31022.png',
    '/cars/gas31029.png',
    '/cars/gas31105.png',
    '/cars/grand.png',
    '/cars/gtr.png',
    '/cars/h5e53.png',
    '/cars/h6nf16.png',
    '/cars/horizon.png',
    '/cars/ic430.png',
    '/cars/imperialgs.png',
    '/cars/k63.png',
    '/cars/kalisto.png',
    '/cars/kompass.png',
    '/cars/kronos.png',
    '/cars/lc5.png',
    '/cars/m5f902020.png',
    '/cars/modestadx.png',
    '/cars/modestae30.png',
    '/cars/moskvich412.png',
    '/cars/n3e30.png',
    '/cars/n3g80.png',
    '/cars/n4f82.png',
    '/cars/n5e39.png',
    '/cars/n5f90.png',
    '/cars/n6e24.png',
    '/cars/n8f82.png',
    '/cars/nebula.png',
    '/cars/nl63.png',
    '/cars/octane.png',
    '/cars/overlander100.png',
    '/cars/overlander300.png',
    '/cars/p8.png',
    '/cars/pc7s8.png',
    '/cars/ph3.png',
    '/cars/praetor200.png',
    '/cars/pulse.png',
    '/cars/q820.png',
    '/cars/qq.png',
    '/cars/rangerfj4.png',
    '/cars/ravesta4xse.png',
    '/cars/ravestaxa20.png',
    '/cars/rc430.png',
    '/cars/regalia.png',
    '/cars/s.png',
    '/cars/s500m222.png',
    '/cars/s560.png',
    '/cars/s600w220.png',
    '/cars/scorpio.png',
    '/cars/shogunxl.png',
    '/cars/siviksph.png',
    '/cars/small/100sc1.png',
    '/cars/small/2000gt.png',
    '/cars/small/2101.png',
    '/cars/small/2112.png',
    '/cars/small/2114.png',
    '/cars/small/220sw111.png',
    '/cars/small/280sew116.png',
    '/cars/small/360.png',
    '/cars/small/510.png',
    '/cars/small/528e12.png',
    '/cars/small/5ka.png',
    '/cars/small/600sl.png',
    '/cars/small/735ie32.png',
    '/cars/small/745leg11.png',
    '/cars/small/750ile38.png',
    '/cars/small/7ka.png',
    '/cars/small/80b2.png',
    '/cars/small/850csie31.png',
    '/cars/small/968M.png',
    '/cars/small/amgx.png',
    '/cars/small/asteroj.png',
    '/cars/small/asteroV.png',
    '/cars/small/b8.png',
    '/cars/small/bluebird910.png',
    '/cars/small/c8t4.png',
    '/cars/small/corsair.png',
    '/cars/small/crc55.png',
    '/cars/small/e63x213.png',
    '/cars/small/elegyr35.png',
    '/cars/small/excelsior.png',
    '/cars/small/expedition.png',
    '/cars/small/gas24.png',
    '/cars/small/gas3102.png',
    '/cars/small/gas31022.png',
    '/cars/small/gas31029.png',
    '/cars/small/gas31105.png',
    '/cars/small/grand.png',
    '/cars/small/gtr.png',
    '/cars/small/h5e53.png',
    '/cars/small/h6nf16.png',
    '/cars/small/horizon.png',
    '/cars/small/ic430.png',
    '/cars/small/imperialgs.png',
    '/cars/small/k63.png',
    '/cars/small/kalisto.png',
    '/cars/small/kompass.png',
    '/cars/small/kronos.png',
    '/cars/small/lc5.png',
    '/cars/small/modestadx.png',
    '/cars/small/modestae30.png',
    '/cars/small/moskvich412.png',
    '/cars/small/n3e30.png',
    '/cars/small/n3g80.png',
    '/cars/small/n4f82.png',
    '/cars/small/n5e39.png',
    '/cars/small/n5f90.png',
    '/cars/small/n6e24.png',
    '/cars/small/n8f92.png',
    '/cars/small/nebula.png',
    '/cars/small/nl63.png',
    '/cars/small/octane.png',
    '/cars/small/overlander100.png',
    '/cars/small/overlander300.png',
    '/cars/small/p8.png',
    '/cars/small/pc7s8.png',
    '/cars/small/ph3.png',
    '/cars/small/praetor200.png',
    '/cars/small/pulse.png',
    '/cars/small/q820.png',
    '/cars/small/qq.png',
    '/cars/small/rangerfj4.png',
    '/cars/small/ravesta4xse.png',
    '/cars/small/ravestaxa20.png',
    '/cars/small/rc430.png',
    '/cars/small/regalia.png',
    '/cars/small/s500m222.png',
    '/cars/small/s560.png',
    '/cars/small/s600w220.png',
    '/cars/small/scorpio.png',
    '/cars/small/shogunxl.png',
    '/cars/small/siviksph.png',
    '/cars/small/sport2.png',
    '/cars/small/sport4.png',
    '/cars/small/subaru360.png',
    '/cars/small/superv.png',
    '/cars/small/sxp.png',
    '/cars/small/taiga2121.png',
    '/cars/small/taigaurban.png',
    '/cars/small/tolyatti8.png',
    '/cars/small/tolyatti99.png',
    '/cars/small/touros.png',
    '/cars/small/townii.png',
    '/cars/small/trailblazer.png',
    '/cars/small/trailstar.png',
    '/cars/small/tundra.png',
    '/cars/small/v140c600.png',
    '/cars/small/venturo.png',
    '/cars/small/verona.png',
    '/cars/small/vista.png',
    '/cars/small/vortex.png',
    '/cars/small/w124.png',
    '/cars/small/zerofade.png',
    '/cars/small/zerofaderz.png',
    '/cars/small/gtr50.png',
    '/cars/small/gt-r50.png',
    '/cars/small/supergt.png',
    '/cars/small/sx90turbos.png',
    '/cars/gtr50.png',
    '/cars/supergt.png',
    '/cars/sx90turbos.png',
    '/cars/sport2.png',
    '/cars/sport4.png',
    '/cars/superv.png',
    '/cars/sxp.png',
    '/cars/taiga2121.png',
    '/cars/taigaurban.png',
    '/cars/tolyatti8.png',
    '/cars/tolyatti99.png',
    '/cars/tourus.png',
    '/cars/townii.png',
    '/cars/trailblazer.png',
    '/cars/trailstar.png',
    '/cars/tundra.png',
    '/cars/v140c600.png',
    '/cars/venturo.png',
    '/cars/verona.png',
    '/cars/vista.png',
    '/cars/vortex.png',
    '/cars/w124.png',
    '/cars/zerofade.png',
    '/cars/n5g60.png',
    '/cars/i63sf.png',
    '/cars/small/n5g60.png',
    '/cars/small/i63sf.png',
    '/cars/zerofaderz.png',
    '/cases/2000GT.png',
    '/cases/CAR_PHANTOM.png',
    '/cases/prizes/Ferrari 250 GTO.png',
    '/cases/prizes/Mercedes-Benz 220s W111.png',
    '/cases/skin.png',
    '/cases/texture.png',
    '/cases/texture_old.png',
    '/effects/blue-ray.png',
    '/icons/1024px/scrap.png',
    '/icons/256px/dp.png',
    '/icons/256px/money.png',
    '/icons/256px/xp.png',
    '/icons/64px/logo.png',
    '/icons/32px/logo.png',
    '/icons/128px/logo.png',
    '/icons/32px/car_icon.png',
    '/icons/32px/checkpoint_icon.png',
    '/icons/24px/check.png',
    '/icons/256px/prem_leaf.webp',
    '/icons/64px/legendary_vehicle.webp',
    '/research/research-tree-background.webp',
    '/icons/32px/clock_icon.png',
    '/icons/32px/dp.png',
    '/icons/32px/money.png',
    '/icons/32px/money_bag.png',
    '/icons/32px/racing_flag.png',
    '/icons/32px/scrap.png',
    '/icons/32px/trophy.png',
    '/icons/32px/xp.png',
    '/icons/32px/xp_icon.png',
    '/icons/64px/drift.png',
    '/icons/arrow.png',
    '/icons/checkbox_checked.png',
    '/icons/checkbox_uncheked.png',
    '/icons/checked.png',
    '/icons/close.png',
    '/icons/finish.png',
    '/icons/light.png',
    '/icons/loader.png',
    '/icons/minimize.png',
    '/icons/modules/brakes.png',
    '/icons/modules/engine.png',
    '/icons/modules/transmission.png',
    '/icons/modules/turbo.png',
    '/icons/modules/tyres.png',
    '/icons/premium.png',
    '/icons/send.png',
    '/icons/standard.png',
    '/icons/tunings/aerials.png',
    '/icons/tunings/air_filter.png',
    '/icons/tunings/arch_cover.png',
    '/icons/tunings/back_wheels.png',
    '/icons/tunings/color_1.png',
    '/icons/tunings/color_2.png',
    '/icons/tunings/dashboard.png',
    '/icons/tunings/dials.png',
    '/icons/tunings/door_speaker.png',
    '/icons/tunings/engine_block.png',
    '/icons/tunings/exhaust.png',
    '/icons/tunings/fender.png',
    '/icons/tunings/frame.png',
    '/icons/tunings/front_bumper.png',
    '/icons/tunings/front_wheels.png',
    '/icons/tunings/grille.png',
    '/icons/tunings/hood.png',
    '/icons/tunings/horns.png',
    '/icons/tunings/hydraulics.png',
    '/icons/tunings/livery.png',
    '/icons/tunings/ornaments.png',
    '/icons/tunings/plaque.png',
    '/icons/tunings/plate_holder.png',
    '/icons/tunings/rear_bumper.png',
    '/icons/tunings/right_fender.png',
    '/icons/tunings/roof.png',
    '/icons/tunings/seats.png',
    '/icons/tunings/shifter_lever.png',
    '/icons/tunings/side_skirt.png',
    '/icons/tunings/speakers.png',
    '/icons/tunings/spoiler.png',
    '/icons/tunings/steering_wheel.png',
    '/icons/tunings/struts.png',
    '/icons/tunings/suspension.png',
    '/icons/tunings/tank.png',
    '/icons/tunings/trim.png',
    '/icons/tunings/trunk.png',
    '/icons/tunings/vanity_plate.png',
    '/icons/tunings/windows.png',
    '/icons/tunings/xenon.png',
    '/inventory/donate/prizes/Mercedes-Benz 220s W111.png',
    '/logo192.png',
    '/logo512.png',
    '/preloaders/preloader_1.png',
    '/underlying.png',
    '/icons/flags/german.png',
    '/icons/flags/japanese.png',
    '/icons/flags/soviet.png',
    '/icons/64px/move.svg',
    '/icons/64px/rotate.svg',
    '/icons/64px/scale.svg',
    '/icons/64px/palette.svg',
    '/icons/32px/cancel.svg',
    '/icons/24px/exclamation_mark.svg',
    '/icons/64px/upload_stencil.svg',
    '/icons/64px/star.svg',
    '/icons/tunings/vinyls.png',
    '/icons/64px/race.png',
    '/icons/64px/fuel.png',
    '/icons/64px/oil.png',
    '/icons/64px/nitro.png',
    '/icons/64px/tyre.png',
    '/icons/256px/race.png',
    '/icons/256px/oil.png',
    '/icons/256px/nitro.png',
    '/icons/256px/tyre.png',
    '/menupictures/akina.webp',
    '/menupictures/bathurst.webp',
    '/menupictures/nurburgring.webp',
    '/menupictures/fujima.webp',
    '/menupictures/monza.webp',
    '/menupictures/san-andreas.webp',
    '/menupictures/lemans.webp',
    '/menupictures/lemans_big.webp',
]